<template>
  <v-container grid-list-md pa-0 ma-2 style="max-width: calc(100% - 16px)">
    <v-form lazy-validation ref="form">
      <v-layout row wrap style="align-items: flex-start">
        <v-flex xs12 md2>
          <v-select
            box
            hide-details
            label="Credor"
            item-text="name"
            item-value="creditor_id"
            @input="isCreditorIdOrNameUpdated = true"
            :items="creditors.objects"
            :rules="[(v) => !!v || 'O credor é obrigatório!']"
            v-model="approachFlow.creditor_id"
            disabled></v-select>
        </v-flex>
        <v-flex xs12 md2>
          <v-text-field
            box
            required
            hide-details
            @input="isCreditorIdOrNameUpdated = true"
            label="Nome"
            :rules="[(v) => !!v || 'O nome é obrigatório!']"
            v-model="approachFlow.name"></v-text-field>
        </v-flex>
        <v-flex xs12 md3>
          <v-text-field
            box
            @input="isCampaignUpdated = true"
            label="Campanha"
            :rules="isCampaignUpdated ? rules : []"
            v-model="approachFlow.campaign"></v-text-field>
        </v-flex>

        <v-tooltip bottom v-if="flowRules.num_results">
          <template v-slot:activator="{ on }">
            <span
              v-on="on"
              class="green lighten-4 green--text text--darken-2"
              style="
                font-size: 15px;
                line-height: 12px;
                padding: 10px 15px;
                border-radius: 20px;
                font-weight: 500;
                margin-top: 20px;
                margin-left: 4px;
              ">
              {{ flowRules.num_results }} {{ flowRules.num_results > 1 ? "eventos" : "evento" }} em
              {{ flowRules.qtd_offset }} {{ flowRules.qtd_offset > 1 ? "dias" : "dia" }}
            </span>
          </template>
          <span>Eventos e Offsets</span>
        </v-tooltip>
        <v-tooltip
          bottom
          v-for="(domain, index) in (approachFlow.configurations || {})
            .domain || []"
          :key="index"
        >
          <template v-slot:activator="{ on }">
            <span
              v-on="on"
              class="orange lighten-4 orange--text text--darken-2"
              style="
                font-size: 15px;
                line-height: 12px;
                padding: 10px 15px;
                border-radius: 20px;
                font-weight: 500;
                margin-top: 17px;
                margin-left: 4px;
                min-height: 36px;
                max-height: 36px;
                cursor: pointer;
              "
              @click="openDialogConfiguration(approachFlow)">
              <v-icon small>mdi-email</v-icon>
              {{ domain }}
            </span>
          </template>
          <span>Seleção dos e-mails por domínio</span>
        </v-tooltip>

        <v-tooltip
          v-if="approachFlow.configurations && approachFlow.configurations.email_sender_prefix"
          bottom>
          <template v-slot:activator="{ on }">
            <v-chip
              v-on="on"
              @click="openDialogConfiguration(approachFlow)"
              color="blue"
              text-color="white"
              class="mt-3 font-weight-medium">
              <v-avatar>
                <v-icon>account_circle</v-icon>
              </v-avatar>
              {{ approachFlow.configurations.email_sender_name || "QuiteJá" }}
              <{{ approachFlow.configurations.email_sender_prefix }}@domínio>
            </v-chip>
          </template>

          <span>Remetente dos e-mails</span>
        </v-tooltip>

        <v-tooltip
          v-if="
            approachFlow.configurations && approachFlow.configurations.whatsapp_sender_phone_number
          "
          bottom>
          <template v-slot:activator="{ on }">
            <v-chip v-on="on" class="mt-4" color="teal" text-color="white">
              <v-icon class="mr-1">mdi-whatsapp</v-icon>
              {{ approachFlow.configurations.whatsapp_sender_phone_number | phoneNumber }}
            </v-chip>
          </template>

          <span>Remetente do WhatsApp</span>
        </v-tooltip>

        <v-tooltip bottom v-if="approachFlow.budget_distribution">
          <template v-slot:activator="{ on }">
            <span
              v-on="on"
              class="yellow lighten-4 black--text text--darken-2"
              style="
                font-size: 15px;

                line-height: 12px;
                padding: 10px 15px;
                border-radius: 20px;
                font-weight: 500;
                margin-top: 17px;
                margin-left: 4px;
                cursor: pointer;
                min-height: 36px;
                max-height: 36px;
              "
              @click="openDialogBudgetDistribution(approachFlow)">
              <v-icon small>attach_money</v-icon>
            </span>
          </template>
          <span>Distribuição <br />de orçamento</span>
        </v-tooltip>
        <v-flex xs10 md3 lg1 class="d-flex align-center mb-5 ml-2">
          <v-btn
            block
            large
            v-show="isCreditorIdOrNameUpdated || isCampaignUpdated"
            :disabled="!(approachFlow.name && approachFlow.creditor_id)"
            @click="save()"
            >Salvar</v-btn
          >
        </v-flex>
        <v-flex class="td-flex" style="justify-content: flex-end">
          <v-menu bottom left max-width="150px">
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="openDialogConfiguration(approachFlow)">
                <v-list-tile-title>Configurações</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="openDialogBudgetDistribution(approachFlow)">
                <v-list-tile-title class="wrap-text">Orçamento (%)</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-flex>
      </v-layout>
    </v-form>
    <v-expand-transition>
      <v-layout wrap v-show="selectedApproach.length >= 1">
        <span class="Editar-Selecionados">
          <v-btn color="accent" style="border-radius: 5px" @click="dialogMultiple = true"
            >Editar Horário dos Selecionados</v-btn
          >
        </span>
        <span class="Deletar-Selecionados">
          <v-btn color="accent" style="border-radius: 5px" @click="remove()"
            >Excluir Múltiplos</v-btn
          >
        </span>
        <v-btn
          flat
          icon
          large
          class="my-0 py-0"
          color="accent"
          @click="
            selectedApproach = [];
            selectAllCheckbox = false;
          ">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-layout>
    </v-expand-transition>
    <v-checkbox v-model="selectAllCheckbox" label="Selecionar Todos"> </v-checkbox>
    <v-flex xs12 md12>
      <v-data-table
        class="approach-table"
        :headers="headers"
        :pagination.sync="pagination"
        align-center
        justify-center
        :items="flowRules.objects"
        no-data-text="Nenhuma abordagem para este credor"
        style="border: 1px solid rgba(0, 0, 0, 0.12); border-radius: 4px">
        <template slot="headerCell" slot-scope="props">
          <v-tooltip top dark>
            <template v-slot:activator="{ on }">
              <span v-on="on">{{ props.header.text }}</span>
            </template>
            <span v-if="props.header.tooltip">{{ props.header.tooltip }}</span>
          </v-tooltip>
        </template>
        <template slot="items" slot-scope="{ item }">
          <tr style="cursor: pointer; height: 96px">
            <td>
              <v-checkbox
                class="qj-checkbox"
                v-model="selectedApproach"
                :value="item.id"></v-checkbox>
            </td>

            <td @dblclick="editRuleData(item)" class="text-no-wrap">
              {{ item.offset }} - {{ item.time.substring(0, 2) }}h
            </td>

            <td
              v-if="item.type"
              class="td-flex"
              id="approach-flow-name"
              @dblclick="editRuleData(item)">
              <div class="d-flex flex-row align-center">
                <div class="mr-2">
                  <span style="height: 22px" :class="`tag-approach-type small ${item.type}`">
                    {{ item.type }}
                  </span>
                </div>

                <div style="width: 100%">
                  <!-- EMAIL -->
                  <template v-if="item.type === 'EMAIL'">
                    <p class="mb-0 subheading" style="font-weight: bold">
                      {{ item.stimulus.subject }}
                    </p>
                    <p
                      class="mb-0 primary--text"
                      style="cursor: pointer"
                      @click="abrirAsset(item.stimulus.url)">
                      {{ item.stimulus.url }}
                    </p>
                  </template>

                  <!-- PUSH -->
                  <template v-else-if="item.type === 'PUSH'">
                    <p class="mb-0 subheading" style="font-weight: bold">
                      {{ item.stimulus.title }}
                    </p>
                    <p class="mb-0">{{ item.stimulus.body }}</p>
                  </template>

                  <!-- SMS -->
                  <template v-else-if="item.type === 'SMS'">
                    <p class="mb-0">{{ item.stimulus.text }}</p>
                  </template>

                  <!-- CALL -->
                  <template
                    v-else-if="item.type === 'CALL_CELLPHONE' || item.type === 'CALL_PHONE'">
                    <p class="mb-0">{{ item.stimulus.type }}</p>
                  </template>

                  <!-- WHATSAPP -->
                  <template v-else-if="item.type === 'WHATSAPP' && item.initiatives">
                    <div style="width: 100%; padding: 6px 0;" class="approach-flow-initiative">
                      <p>
                        <template>
                          <span>
                            <span class="font-weight-bold">{{ item.initiatives.name }}</span> [
                            <i>{{ item.initiatives.key }}</i> ]
                          </span>
                        </template>

                        <span
                          :class="[
                            item.initiatives.meta_status,
                            item.initiatives.meta_quality_score,
                          ]"
                          class="initiative_selector_initiative--status mr-1"
                          v-if="item.initiatives.meta_status">
                          {{ item.initiatives.meta_status | whatsappTemplateStatus }}
                        </span>

                        <QualityChip
                          v-if="
                            item.initiatives.meta_status == 'APPROVED' &&
                            item.initiatives.meta_quality_score
                          "
                          :quality="item.initiatives.meta_quality_score"
                        ></QualityChip>

                        <span class="ml-2" v-if="item.initiatives.creditor_id"> ★ </span>

                        <v-chip class="py-0 my-0" small dense outline>
                          <span v-if="item.initiatives.meta_category === 'MARKETING'"
                            >Marketing</span
                          >
                          <span v-else-if="item.initiatives.meta_category === 'UTILITY'"
                            >Utilidade</span
                          >
                          <span v-else-if="item.initiatives.meta_category === 'AUTHENTICATION'"
                            >Autenticação</span
                          >
                          <span v-else>{{ item.initiatives.meta_category }}</span>
                        </v-chip>

                        <ApprovalIcon
                          :approved="item.initiatives.approved"
                          :approvedBy="item.initiatives.approved_by"
                          :approvedAt="item.initiatives.approved_at"
                        ></ApprovalIcon>

                        <MessageInconsistencyAlert
                          :inconsistencies="item.initiatives && item.initiatives.message_inconsistencies"
                        />

                      </p>

                      <p>
                        <span v-if="item.initiatives.sender">
                          <i>#{{ item.initiatives.sender.id }}</i>
                          {{ item.initiatives.sender.phone_number | phoneNumber }}
                        </span>

                        <span
                          v-if="
                            item.initiatives.sender &&
                            item.initiatives.sender.meta_quality_rating_v2
                          "
                          class="initiative_selector_sender--status"
                          :class="[item.initiatives.sender.meta_quality_rating_v2]">
                          {{
                            item.initiatives.sender.meta_quality_rating_v2 | whatsappSenderQuality
                          }}
                        </span>

                        <FlaggedIcon
                          v-if="
                            item.initiatives.sender &&
                            item.initiatives.sender.meta_status === 'FLAGGED'
                          "
                        ></FlaggedIcon>
                      </p>

                      <FallbackInitiativesDisplay
                        v-if="fallbackSummaryByRuleId[item.id]"
                        class="mt-1"
                        :items="fallbackSummaryByRuleId[item.id].items"
                      ></FallbackInitiativesDisplay>
                    </div>
                  </template>

                  <template v-else-if="item.type === 'WHATSAPP'">
                    <p class="mb-0 error--text">Iniciativa não encontrada</p>
                  </template>
                </div>
              </div>

              <div class="d-flex flex-row align-center">
                <v-tooltip top v-if="inactiveFallbackTooltipByRuleId[item.id]">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" class="mr-2" v-on="on">mdi-alert</v-icon>
                  </template>
                  <span>{{ inactiveFallbackTooltipByRuleId[item.id] }}</span>
                </v-tooltip>

                <!-- Tooltip de oferta -->
                <v-tooltip top v-if="item.offer_type">
                  <template v-slot:activator="{ on }">
                    <span
                      v-on="on"
                      class="blue lighten-4 blue--text text--darken-2"
                      style="
                        font-size: 13px;
                        line-height: 12px;
                        padding: 2px 4px;
                        border-radius: 4px;
                        font-weight: 500;
                        margin-left: 4px;
                      ">
                      {{ item.offer_type.description }}
                    </span>
                  </template>
                  <span>Ofertas</span>
                </v-tooltip>

                <!-- Menu -->
                <v-menu bottom left>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-tile @click="editRuleData(item)">
                      <v-list-tile-title>Editar</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="deleteRuleAction(item)">
                      <v-list-tile-title>Excluir</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>

    <DialogApproachFlowEdit
      :dialog.sync="dialog"
      :fab.sync="fab"
      :currentRuleType.sync="currentRuleType"
      :addButtons="addButtons"
      :approachFlow="approachFlow"
      :currentFlowRule="currentFlowRule"
      :failureText.sync="failureText"
      :allowedTimes="allowedTimes"
      :allowedTimesEmail="allowedTimesEmail"
      :message.sync="message"
      :variables="variables"
      :contentLength="contentLength"
      :alert.sync="alert"
      :push="push"
      :links="links"
      :email="email"
      :call="call"
      :callCampaigns="callCampaigns"
      :initiativeId="initiativeId"
      @update:initiativeId="handleInitiativeIdChange"
      :initiativeObj.sync="initiativeObj"
      :fallbackEnabled.sync="fallbackEnabled"
      :fallbackInitiativeIds.sync="fallbackInitiativeIds"
      :primaryBroker="primaryBroker"
      :primaryCreditorId="primaryCreditorId"
      :configMce="configMce"
      :switchShow.sync="switchShow"
      :variableSelected="variableSelected"
      :offerTypes="offerTypes"
      :previewWppDialog.sync="previewWppDialog"
      :loading-preview="loadingPreview"
      :contentValid="contentValid"
      @save-data="saveData"
      @var-click="varClick"
    />

    <v-dialog
      id="approachFlowTime"
      scrollable
      persistent
      max-width="35vw"
      max-height="50vh"
      v-model="dialogMultiple">
      <v-card>
        <v-card-title>
          <span class="headline"> Editar Datas</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pb-0">
          <v-layout wrap>
            <v-flex shrink class="mx-1" style="width: 100px">
              <v-select
                label="Horário"
                item-text="text"
                item-value="value"
                :items="allowedTimesEmail"
                v-model="selectMultipleTime"></v-select>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-layout class="pa-2" row wrap>
            <v-spacer></v-spacer>
            <v-btn
              outline
              color="primary"
              style="margin-top: 6px"
              @click="
                dialogMultiple = false;
                selectMultipleTime = null;
              ">
              Fechar
            </v-btn>
            <v-btn
              x-large
              color="primary"
              class="elevation-0"
              style="margin-top: 6px"
              :disabled="!selectMultipleTime"
              @click="editMultipleTimes()">
              Salvar
            </v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-dialog v-model="dialogConfirm" persistent width="400">
      <v-card>
        <v-card-text style="height: 100px">
          <h2 class="text-xs-center mt-4">Tem certeza que quer excluir a mensagem?</h2>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            outline
            dark
            @click="
              dialogConfirm = false;
              selectedApproach = [];
            ">
            Não
          </v-btn>
          <v-btn class="elevation-1" color="primary" dark @click="remove()"> Sim </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <DialogConfiguration
      :data="dataDialogConfiguration"
      :dialog.sync="dialogConfiguration"
      :approach_id="configurationApproachId"
      :isCampaign="isCampaign"
      :approachFlow="approachFlow"
      :isCreditorIdOrNameUpdated="isCreditorIdOrNameUpdated" />
    <DialogBudgetDistribution
      :data="dataDialogConfiguration"
      :dialog.sync="dialogBudgetDistribution"
      :approach_id="configurationApproachId"
      :approachFlow="approachFlow"
      :flowRules="flowRules" />
    <DialogAsset
      v-if="openAsset"
      :dialog.sync="openAsset"
      :linkAsset="assetUrl"
      @close="() => (openAsset = false)" />
    <v-snackbar v-model="show_snack" :timeout="0" :top="true">
      {{ snack_text }}
      <v-btn flat icon color="error" @click.stop="show_snack = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <InitiativePreview :previewDialog.sync="previewWppDialog"> </InitiativePreview>
  </v-container>
</template>

<script>
//utils
import approachType from "@/utils/approach-type";
import variables from "@/utils/message-variables";
//services
import approachService from "@/services/consolidation-tree/approach-flow";
import offerService from "@/services/offer";
import approachRuleService from "@/services/consolidation-tree/approach-flow-rule";
import callCampaignService from "@/services/consolidation-tree/call-campaign";
import creditorService from "@/services/creditor";
import initiativesService from "@/views/initiativeManager/service";
//components
import InitiativePreview from "@/views/initiativeManager/components/Preview/Preview";
import textAreaAutocomplete from "@/components/TextAreaAutocomplete";
import DialogConfiguration from "./components/dialogs/dialogConfigurationApproachFlow.vue";
import DialogBudgetDistribution from "./components/dialogs/dialogApproachFlowBudgetDistribution.vue";
import DialogAsset from "./components/dialogs/dialogAssetLink.vue";
import ApprovalIcon from "@/components/ui/ApprovalIcon.vue";
import FlaggedIcon from "@/components/ui/FlaggedIcon.vue";
import QualityChip from "@/components/ui/QualityChip.vue";
import MessageInconsistencyAlert from "@/components/ui/MessageInconsistencyAlert.vue";
import DialogApproachFlowEdit from "./components/dialogs/dialogApproachFlowEdit.vue";
import FallbackInitiativesDisplay from "./components/fallbackInitiativesDisplay.vue";

import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  props: ["approach_id"],
  components: {
    InitiativePreview,
    textAreaAutocomplete,
    DialogConfiguration,
    DialogAsset,
    DialogBudgetDistribution,
    ApprovalIcon,
    FlaggedIcon,
    QualityChip,
    MessageInconsistencyAlert,
    DialogApproachFlowEdit,
    FallbackInitiativesDisplay,
  },
  data: () => ({
    pagination: {
      rowsPerPage: 100,
    },
    loadingPreview: false,
    addButtons: [],
    show_snack: false,
    openAsset: false,
    assetUrl: "",
    snack_text: "",
    fab: false,
    menu: false,
    isCampaign: false,
    flowRules: [],
    currentFlowRule: { offset: 1 },
    callCampaigns: [],
    dataDialogConfiguration: {},
    alert: true,
    offerTypes: [],
    variables_array: [],
    failureText: "",
    dialog: false,
    dialogConfiguration: false,
    dialogBudgetDistribution: false,
    configurationApproachId: null,
    isCreditorIdOrNameUpdated: false,
    isCampaignUpdated: false,
    previewWppDialog: false,
    selectedApproach: [],
    selectAllCheckbox: false,
    unselectApproach: false,
    dialogMultiple: false,
    selectMultipleTime: null,
    rules: [
      (value) =>
        !value.length >= 1 ||
        "Ao editar a campanha, os contatos serão reiniciados no dia inicial da abordagem",
    ],
    switchShow: false,
    dialogConfirm: false,
    currentRuleType: null,
    links: ["$LINK", "$LINK_REDIRECT", "$LINK_WHATSAPP", "$LINK_FOMENTATION", "$LINK_ME_LEMBRE"],
    itemToBeDeleted: null,
    creditors: {
      objects: [],
    },
    approachFlow: {
      name: "",
      campaign: "",
      creditor_id: "",
      domains_length: 0,
      budget_distribution: false,
    },
    initiativeId: null,
    initiativeObj: null,
    fallbackEnabled: false,
    fallbackInitiativeIds: [],
    fallbackInitiativesById: {},
    pushs: [],
    emails: [],
    messages: [],
    contentLength: 0,
    message: "",
    push: {
      body: "",
      title: "",
      link: "$LINK",
    },
    email: {
      subject: "",
      template: "",
      url: "",
    },
    call: {
      type: "",
      campaign: null,
    },
    headers: [
      {
        text: "",
        align: "left",
        sortable: false,
        width: "5%",
      },
      {
        text: "Offset",
        align: "left",
        sortable: false,
        width: "5%",
      },
      {
        text: "Conteúdo",
        sortable: false,
      },
    ],
    allowedTimes: [
      { text: "8h", value: "08:00:00" },
      { text: "9h", value: "09:00:00" },
      { text: "10h", value: "10:00:00" },
      { text: "11h", value: "11:00:00" },
      { text: "12h", value: "12:00:00" },
      { text: "13h", value: "13:00:00" },
      { text: "14h", value: "14:00:00" },
      { text: "15h", value: "15:00:00" },
      { text: "16h", value: "16:00:00" },
      { text: "17h", value: "17:00:00" },
      { text: "18h", value: "18:00:00" },
      { text: "19h", value: "19:00:00" },
    ],
    allowedTimesEmail: [
      { text: "4h", value: "04:00:00" },
      { text: "5h", value: "05:00:00" },
      { text: "6h", value: "06:00:00" },
      { text: "7h", value: "07:00:00" },
      { text: "8h", value: "08:00:00" },
      { text: "9h", value: "09:00:00" },
      { text: "10h", value: "10:00:00" },
      { text: "11h", value: "11:00:00" },
      { text: "12h", value: "12:00:00" },
      { text: "13h", value: "13:00:00" },
      { text: "14h", value: "14:00:00" },
      { text: "15h", value: "15:00:00" },
      { text: "16h", value: "16:00:00" },
      { text: "17h", value: "17:00:00" },
      { text: "18h", value: "18:00:00" },
      { text: "19h", value: "19:00:00" },
    ],
    configMce: {
      language: "pt_BR",
      height: "250",
      branding: false,
      language_url: "tinymce-language-pt_BR.js",
      theme: "modern",
      fontsize_formats: "8px 10px 12px 14px 16px 18px 20px 22px 24px 26px 39px 34px",
      plugins: "preview fullpage searchreplace autolink",
      toolbar1: "formatselect fontsizeselect | bold italic strikethrough forecolor backcolor link",
    },
  }),
  async created() {
    await this.getCreditors();
    await this.getOfferType();
    await this.getApproachRule();
    await this.getApproach();
    await this.getCallCampaings();

    this.variables_array = variables.variables;
    this.isCampaign = this.approachFlow.campaign ? true : false;
    let approachsTypes = approachType.approachType.map((e) => e);
    this.addButtons = approachsTypes.filter((el) =>
      ["EMAIL", "SMS", "PUSH", "CALL", "WHATSAPP"].includes(el.value)
    );
  },
  computed: {
    ...mapGetters("initiativeManager", ["initiativesList", "selectedInitiative"]),

    primaryBroker() {
      return this.initiativeObj && this.initiativeObj.sender
        ? this.initiativeObj.sender.owner
        : null;
    },

    primaryCreditorId() {
      return this.initiativeObj ? this.initiativeObj.creditor_id : null;
    },

    fallbackSummaryByRuleId() {
      const rules = (this.flowRules && this.flowRules.objects) || [];
      return rules.reduce((summary, rule) => {
        const ids = this.getFallbackIds(rule);
        if (!ids.length) return summary;
        const items = ids.map((id) => this.buildFallbackEntry(id));
        summary[rule.id] = {
          items,
          inactiveCount: items.filter((entry) => entry.isInactive).length,
        };
        return summary;
      }, {});
    },

    inactiveFallbackTooltipByRuleId() {
      return Object.keys(this.fallbackSummaryByRuleId).reduce((tooltips, ruleId) => {
        const { inactiveCount } = this.fallbackSummaryByRuleId[ruleId];
        if (!inactiveCount) return tooltips;
        tooltips[ruleId] =
          inactiveCount > 1
            ? `${inactiveCount} iniciativas alternativas inativas: não serão enviadas`
            : "1 iniciativa alternativa inativa: não será enviada";
        return tooltips;
      }, {});
    },

    contentValid() {
      let valid = false;
      let array_variables = this.variables_array;
      array_variables = array_variables.map((variable) => String(variable.name));

      if (this.currentRuleType == "SMS" || this.currentRuleType == "SMS_FLASH") {
        this.contentLength = this.message.length;
        if (this.message == "") return false;
        if (this.message.includes(" $ ")) return false;
        if (!this.message.match(/\$LINK[A-Z_0-9]*/)) return false;
        let v = this.message.matchAll(/^\$([A-Z_0-9]*)/g);
        v = Array.from(v);
        v = v.map((x) => x[0]);
        for (const idx in v) {
          if (!array_variables.includes(v[idx]) || v[idx] == "$") {
            this.snack_text = `O campo ${v[idx]} foi encontrado porém não é uma variável permitida!`;
            this.show_snack = true;
            return false;
          }
        }

        for (const idx in array_variables) {
          let u = this.message.includes(array_variables[idx].replace("$", " "));
          let w = !this.message.includes(array_variables[idx]);
          if (
            this.message.includes(array_variables[idx].replace("$", " ")) &&
            !this.message.includes(array_variables[idx])
          ) {
            this.snack_text = `Possível variável ${array_variables[idx]} encontrada, porém digitada incorretamente!`;
            this.show_snack = true;
            return false;
          }
        }

        let message = this.message;
        this.variables.forEach((e) => {
          if (message.includes(e.name)) {
            let randomString = Math.random().toString(2).substring(0, e.length);
            message = message.replace(e.name, randomString);
            this.contentLength = message.length;
          }
        });
        if (this.contentLength <= 160) valid = true;
      }

      if (this.currentRuleType == "PUSH") {
        if (
          this.push.body &&
          this.push.title &&
          this.push.body.length > 0 &&
          this.push.title.length > 0
        )
          valid = true;
      }

      if (this.currentRuleType == "EMAIL_TEXT" || this.currentRuleType == "EMAIL") {
        if (
          this.email.subject &&
          this.email.subject.length > 0 &&
          this.isValidHttpUrl(this.email.url)
        )
          valid = true;
      }

      if (["CALL", "CALL_PHONE", "CALL_CELLPHONE"].includes(this.currentRuleType)) {
        if (this.call.type != "" && Number.isInteger(this.call.campaign)) {
          valid = true;
        }
      }

      if (this.currentRuleType == "WHATSAPP") {
        if (this.initiativeId) valid = true;
      }
      if (!this.currentFlowRule.offset || !this.currentFlowRule.time) valid = false;
      this.show_snack = false;
      return valid;
    },
    variableSelected() {
      let vm = this;
      if (vm.currentRuleType == "SMS" || vm.currentRuleType == "SMS_FLASH") {
        let message = this.message;
        for (let i = 0; i < vm.variables.length; i++) {
          if (message.includes(vm.variables[i].name)) {
            let randomString = Math.random().toString(2).substring(0, vm.variables[i].length);
            message = message.replace(vm.variables[i].name, randomString);
            vm.variables[i]["selected"] = true;
          } else {
            vm.variables[i]["selected"] = false;
          }
        }
      } else {
        return false;
      }
    },
    variables() {
      if (!this.approachFlow.creditor_id || !this.creditors.objects.length) return [];

      let allowed_variables =
        this.creditors.objects.find((c) => c.creditor_id == this.approachFlow.creditor_id)
          .allowed_variables || [];

      if (!allowed_variables.length) return this.variables_array;

      return this.variables_array.filter((item) => allowed_variables.includes(item.name));
    },
  },
  watch: {
    async dialog() {
      if (!this.dialog) {
        this.initiativeId = null;
        this.initiativeObj = null;
        this.fallbackEnabled = false;
        this.fallbackInitiativeIds = [];
        this.clearSelectedInitiative();
        this.toggle_exclusive = false;
        this.failureText = "";
        this.currentFlowRule = {};
        this.reloadFields();
        this.currentRuleType = this.currentRuleType;
      } else {
        if (!this.currentFlowRule.id) {
          this.reloadFields();
          for (let i = 0; i < this.variables.length; i++) {
            this.variables[i]["selected"] = false;
          }
          this.currentFlowRule.time = "12:00:00";
          if (this.flowRules.length) {
            this.currentFlowRule.offset = this.flowRules[this.flowRules.length - 1].offset + 1;
          } else {
            this.currentFlowRule.offset = 1;
          }
        }
      }
    },
    dialogConfirm() {
      if (!this.dialogConfirm) this.toggle_exclusive = false;
    },
    selectedApproach() {
      if (this.selectedApproach.length == 0) {
        this.selectAllCheckbox = false;
        this.unselectApproach = false;
        this.dialogMultiple = false;
        this.selectMultipleTime = null;
      } else if (this.selectedApproach.length < this.flowRules.objects.length) {
        this.selectAllCheckbox = false;
        this.unselectApproach = true;
      } else if (this.selectedApproach.length === this.flowRules.objects.length) {
        this.selectAllCheckbox = true;
        this.unselectApproach = false;
      }
    },
    selectAllCheckbox(newVal) {
      if (newVal == true) {
        this.flowRules.objects.forEach(({ id }) => {
          if (this.selectedApproach.includes(id)) return;
          else this.selectedApproach.push(id);
        });
        this.unselectApproach = false;
      } else if (this.unselectApproach) {
        this.unselectApproach = false;
      } else {
        this.selectedApproach = [];
      }
    },
    async previewWppDialog(open = false) {
      if (open) {
        let previewInitiative = this.initiativesList.find((i) => i.id === this.initiativeId);
        if (!previewInitiative) {
          this.loadingPreview = true;
          try {
            previewInitiative = await initiativesService.getInitiative(this.initiativeId);
            this.setSelectedInitiative(previewInitiative);
          } catch (error) {
            console.error("Erro ao carregar iniciativa selecionada:", error.message);
            this.clearSelectedInitiative();
            this.$store.commit("showSnackbar", {
              message: "Erro ao visualizar iniciativa selecionada",
              color: "error",
            });
          } finally {
            this.loadingPreview = false;
          }
        } else {
          this.setSelectedInitiative(previewInitiative);
        }
      } else {
        this.clearSelectedInitiative();
      }
    },
  },
  methods: {
    ...mapMutations("initiativeManager", ["setSelectedInitiative", "clearSelectedInitiative"]),
    ...mapActions("initiativeManager", ["getAllInitiatives"]),
    async handleInitiativeIdChange(newInitiativeId) {
      if (newInitiativeId !== this.initiativeId) {
        this.fallbackEnabled = false;
        this.fallbackInitiativeIds = [];
      }
      this.initiativeId = newInitiativeId;
      if (!newInitiativeId) {
        this.initiativeObj = null;
        return;
      }
      try {
        const response = await initiativesService.getInitiative(newInitiativeId);
        this.initiativeObj = response || null;
      } catch (error) {
        console.error("Erro ao carregar dados da iniciativa selecionada:", error.message);
        this.$store.commit("showSnackbar", {
          message: "Não foi possível carregar os dados da iniciativa selecionada",
          color: "error",
        });
      }
    },
    async getCreditors() {
      await creditorService
        .list()
        .then((res) => (this.creditors = res))
        .catch((err) => console.error(err));
    },
    async getApproach() {
      await approachService
        .findById(this.approach_id)
        .then((res) => {
          this.approachFlow = res;
          if (this.approachFlow.configurations && this.approachFlow.configurations.domain) {
            this.approachFlow.domains_length = this.approachFlow.configurations.domain.length;
          }
          if (
            this.approachFlow.configurations &&
            this.approachFlow.configurations.budget_distribution
          ) {
            this.approachFlow.budget_distribution =
              this.approachFlow.configurations.budget_distribution;
          }
        })
        .catch((err) => console.error(err));
    },
    async getOfferType() {
      await offerService
        .list()
        .then((res) => (this.offerTypes = res))
        .catch((err) => console.error(err));
    },
    async getApproachRule() {
      this.flowRules = await approachRuleService.list(this.approach_id);
      let offsets = [];
      this.flowRules.objects.sort((a, b) => {
        offsets.push(a.offset);
        offsets.push(b.offset);
        if (a.offset < b.offset) return -1;
        if (a.offset > b.offset) return 1;
        if (a.offset == b.offset && a.time < b.time) return -1;
        if (a.offset == b.offset && a.time > b.time) return 1;
        if (a.offset == b.offset && a.time == b.time && a.type == "SMS" && b.type != "SMS")
          return -1;
        if (a.offset == b.offset && a.time == b.time && a.type == "PUSH" && b.type == "EMAIL")
          return -1;
        if (a.offset == b.offset && a.time == b.time && a.type == "PUSH" && b.type == "SMS")
          return 1;
        if (a.offset == b.offset && a.time == b.time && a.type == "EMAIL") return 1;
        return 0;
      });
      offsets = [...new Set(offsets)];

      this.flowRules.qtd_offset = this.flowRules.num_results === 1 ? 1 : offsets.length;

      this.selectedApproach = [];
      this.loadFallbackInitiatives();
    },
    getFallbackIds(rule) {
      if (!rule || rule.type !== "WHATSAPP" || !rule.stimulus) return [];
      const ids = rule.stimulus.fallback_initiative_ids;
      if (!Array.isArray(ids)) return [];
      return ids.filter((id) => !!id);
    },
    buildFallbackEntry(id) {
      const cached = this.fallbackInitiativesById[id];
      const initiative = cached ? cached.initiative : null;
      return {
        id,
        initiative,
        isLoading: !cached,
        isFailed: !!(cached && cached.failed),
        isInactive: !!(initiative && initiative.active !== true),
      };
    },
    async fetchFallbackInitiative(id) {
      try {
        const initiative = await initiativesService.getInitiative(id);
        return { id, initiative: initiative || null, failed: !initiative };
      } catch (error) {
        console.error(`Erro ao carregar iniciativa alternativa #${id}:`, error);
        return { id, initiative: null, failed: true };
      }
    },
    async loadFallbackInitiatives() {
      const rules = (this.flowRules && this.flowRules.objects) || [];
      const ids = [
        ...new Set(rules.reduce((acc, rule) => acc.concat(this.getFallbackIds(rule)), [])),
      ];
      if (!ids.length) return;

      const results = await Promise.all(ids.map((id) => this.fetchFallbackInitiative(id)));
      const updated = { ...this.fallbackInitiativesById };
      results.forEach(({ id, initiative, failed }) => {
        updated[id] = { initiative, failed };
      });
      this.fallbackInitiativesById = updated;
    },
    async getCallCampaings() {
      await callCampaignService
        .list()
        .then((res) => (this.callCampaigns = res.objects))
        .catch((err) => {
          console.error(err);
          alert("Não foi possível encontrar as campanhas");
        });
    },
    findCallCampaing(campaign_id) {
      return this.callCampaigns.find((el) => {
        return el.id == campaign_id;
      });
    },
    save() {
      approachService
        .save({
          id: this.approachFlow.id,
          name: this.approachFlow.name,
          campaign: this.approachFlow.campaign ? this.approachFlow.campaign : null,
          configurations: this.approachFlow.configurations
            ? this.approachFlow.configurations
            : null,
          creditor_id: this.approachFlow.creditor_id,
        })
        .then((res) => {
          if (res == undefined) {
            console.error("houve um erro");
            this.$store.commit("showSnackbar", {
              message: "Houve um erro ao salvar",
            });
          } else {
            this.$store.commit("showSnackbar", {
              message: "Abordagem salva com sucesso!",
              important: true,
            });
            this.isCreditorIdOrNameUpdated = false;
            this.isCampaignUpdated = false;
            this.getApproach();
          }
        })
        .catch((error) => {
          console.error(error);
          this.$store.commit("showSnackbar", {
            message: "Houve um erro ao salvar",
          });
        });
    },
    varClick(value) {
      let sp = value ? " " : "";
      value = !value ? "" : value;
      if (this.currentRuleType == "SMS" || this.currentRuleType == "SMS_FLASH") {
        if (this.message != "") {
          if (this.message[this.message.length - 1] != sp) {
            value = sp + value;
          }
        }
        this.message += value;
      } else if (this.currentRuleType == "PUSH") {
        this.push.body = this.push.body + sp + value;
      } else if (this.currentRuleType == "EMAIL") {
        this.email.subject = this.email.subject + sp + value;
      }
    },
    saveData() {
      let item = {};
      let payload = {};
      let stimulus = {};
      let currentFlowRule = Object.assign({}, this.currentFlowRule);

      if (this.currentRuleType == "SMS" || this.currentRuleType == "SMS_FLASH") {
        stimulus = {
          text: this.message.trim(),
        };
      } else if (this.currentRuleType == "PUSH") {
        item = Object.assign({}, this.push);
        stimulus = {
          title: item.title.trim(),
          body: item.body.trim(),
          link: item.link,
        };
      } else if (["CALL", "CALL_PHONE", "CALL_CELLPHONE"].includes(this.currentRuleType)) {
        item = Object.assign({}, this.call);
        stimulus = {
          campaign: item.campaign,
          firing_type: "AUTO",
          type: item.type,
        };
      } else if (this.currentRuleType == "WHATSAPP") {
        stimulus = {
          key: this.selectedInitiative.key,
          initiative_id: this.initiativeId,
          version: this.selectedInitiative.version,
          fallback_initiative_ids: this.fallbackEnabled
            ? this.fallbackInitiativeIds.filter((id) => !!id)
            : [],
        };
      } else {
        item = Object.assign({}, this.email);
        stimulus = {
          subject: item.subject.trim(),
          url: item.url.trim(),
          template: item.template.trim(),
        };
      }

      if (["CALL", "CALL_PHONE", "CALL_CELLPHONE"].includes(this.currentRuleType)) {
        payload["type"] = stimulus.type;
      } else {
        payload["type"] = this.currentRuleType;
      }
      (payload["approach_flow_id"] = parseInt(this.approach_id)),
        (payload["offset"] = currentFlowRule.offset);
      payload["stimulus"] = stimulus;
      payload["time"] = currentFlowRule.time;
      payload["offer_type_id"] = currentFlowRule.offer_type_id
        ? currentFlowRule.offer_type_id
        : null;
      approachRuleService
        .save(payload, currentFlowRule.id)
        .then(async (resp) => {
          this.$store.commit("showSnackbar", {
            message: "Mensagem salva com sucesso!",
            important: true,
          });
          await this.getApproachRule();
          this.dialog = false;
        })
        .catch((err) => {
          console.error(err);
          if (err.response && err.response.status == 422) {
            this.failureText = `Já existe um ${this.currentRuleType} para este dia e horário.`;
          }
        });
    },
    editMultipleTimes() {
      let payload = { list: this.selectedApproach, time: this.selectMultipleTime };
      approachRuleService
        .saveMultiple(payload)
        .then(async (resp) => {
          this.$store.commit("showSnackbar", {
            message: "Lista dos horários salva com sucesso!",
            important: true,
          });
        })
        .finally(async () => {
          await this.getApproachRule();
          this.dialogMultiple = false;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    editRuleData(item) {
      this.dialog = true;
      this.currentFlowRule = Object.assign({}, item);
      this.currentRuleType = item.type;
      setTimeout(async () => {
        if (item.type == "SMS") {
          this.message = item.stimulus.text || "";
        } else if (item.type == "PUSH") {
          this.push = Object.assign({}, item.stimulus);
        } else if (item.type == "EMAIL") {
          this.email = Object.assign({}, item.stimulus);
        } else if (["CALL_PHONE", "CALL_CELLPHONE"].includes(item.type)) {
          this.call = Object.assign({}, item.stimulus);
        } else if (item.type == "WHATSAPP") {
          this.initiativeId = item.stimulus.initiative_id || null;
          this.initiativeObj = item.initiatives || null;
          this.fallbackInitiativeIds = (item.stimulus.fallback_initiative_ids || []).slice(0, 4);
          this.fallbackEnabled = this.fallbackInitiativeIds.length > 0;
        }
      }, 100);
    },
    deleteRuleAction(item) {
      this.itemToBeDeleted = Object.assign({}, item);
      this.dialogConfirm = true;
    },
    remove() {
      if (this.itemToBeDeleted) {
        this.selectedApproach.push(this.itemToBeDeleted.id);
      }
      approachRuleService
        .remove(this.selectedApproach)
        .then((res) => {
          this.$store.commit("showSnackbar", {
            message: "Mensagem excluída com sucesso!",
            important: true,
          });
        })
        .catch((err) => {
          console.error(err);
          alert("Não foi possível excluir a mensagem");
        })
        .finally(async () => {
          this.selectedApproach = [];
          this.itemToBeDeleted = null;
          await this.getApproachRule();
          this.dialogConfirm = false;
        });
    },
    reloadFields() {
      setTimeout(() => {
        this.message = null;

        this.push.body = "";
        this.push.title = "";
        this.push.link = "$LINK";
        this.email.subject = "";
        this.email.url = "";
        this.call.type = "";
        this.call.campaign = {};
        this.alert = true;

        this.message = "";
        this.contentLength = 0;
        this.useEmailTemplate = false;
      }, 500);
    },
    isValidHttpUrl(string) {
      let url;
      try {
        url = new URL(string);
      } catch (_) {
        return false;
      }
      return url.protocol === "http:" || url.protocol === "https:";
    },

    order(list) {
      let newOrder = [...list];
      newOrder.sort((a, b) => {
        let timeA = parseInt(a.time.split(":")[0]);
        let timeB = parseInt(b.time.split(":")[0]);

        if (timeA < timeB) return -1;
        if (timeA > timeB) return 1;
        return 0;
      });
      return newOrder;
    },
    openDialogConfiguration(approachFlow) {
      this.configurationApproachId = approachFlow.id;
      this.dataDialogConfiguration = approachFlow.configurations;
      this.dialogConfiguration = true;
    },
    openDialogBudgetDistribution(approachFlow) {
      this.configurationApproachId = approachFlow.id;
      this.dataDialogConfiguration = approachFlow.configurations;
      this.dialogBudgetDistribution = true;
    },
    abrirAsset(link) {
      this.assetUrl = link;
      this.openAsset = true;
    },
  },
};
</script>

<style lang="scss">
.header-filter {
  display: flex;
  flex-direction: column;
}
.approach-table {
  .td-flex {
    display: flex;
    align-items: flex-end !important;
    flex-direction: row;
    justify-content: space-between;
  }
}
.list-time .v-list__tile {
  padding: 0 0 0 8px;
}

.var-content {
  border-radius: 12px;
  padding: 2px 0px;
}

.var-container {
  max-height: 600px;
  overflow: auto;
}
#approach-flow-name {
  height: inherit !important;
  margin: auto 0px !important;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-content: center !important;
  align-items: center !important;
  & > div:first-child {
    margin: auto 0;
  }
  & > div:last-child {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
    span {
      margin: auto !important;
    }
    button {
    }
  }
}
</style>

<style scoped lang="scss">
.td-flex {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 100% !important;
  @media (min-width: 900px) {
    flex-direction: row;
    align-items: center;
  }
}
.qj-checkbox {
  margin: 24px 0px 0px 25px !important;
  flex: unset !important;
}
.wrap-text {
  white-space: normal;
}
.sender-name {
  font-size: 14px;
}
.quality-small {
  font-size: 13px;
}
.approach-flow-initiative {
  .initiative_selector_initiative--status {
    border: 1px solid;
    border-radius: 2px;
    font-weight: 500;
    padding: 1px 2px;
    white-space: nowrap;
    font-size: 12px;

    &.APPROVED {
      background-color: #ebf5f1;
      border-color: #b6d1c6;
      color: #247058;
    }

    &.APPROVED.LOW {
      background-color: #fff0f1;
      border-color: #facfd4;
      color: #ab1628;
    }

    &.APPROVED.MEDIUM {
      background-color: #fff8e3;
      border-color: #ffe299;
      color: #ad7410;
    }

    &.DISABLED,
    &.UNKNOWN {
      background-color: #e5e5e3;
      border-color: #a6a5a2;
      color: #545452;
    }

    &.FIRST_PAUSED,
    &.UNKNOWN {
      background-color: #e5e5e3;
      border-color: #a6a5a2;
      color: #545452;
    }

    &.SECOND_PAUSED,
    &.UNKNOWN {
      background-color: #e5e5e3;
      border-color: #a6a5a2;
      color: #545452;
    }

    &.PAUSED,
    &.FIRST_PAUSED,
    &.SECOND_PAUSED {
      background-color: #fff8e3;
      border-color: #ffe299;
      color: #ad7410;
    }

    &.PENDING_DELETION,
    &.REJECTED {
      background-color: #fff0f1;
      border-color: #facfd4;
      color: #ab1628;
    }
  }
}
</style>
